import { useDispatch, useSelector } from "react-redux";
import {
  authModalHandler,
  isUpdatingEmailStatus,
  postStudioEmail,
  verifyEmailOtp,
  postResendStudioEmail,
} from "../../store/slices/Preference/studioDetailstSlice";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updatePreferenceList } from "../../store/slices/GetStarted/userBasicDataSlice";

export const useEmailVerify = () => {
  const [code, setCode] = useState("");
  const [showErrors, setShowErrors] = useState("");
  const [showOtpErrors, setshowOtpErrors] = useState(null);
  const [otpCounter, setOtpCounter] = useState(180);

  const dispatch = useDispatch();
  const { isUpdatingEmail } = useSelector((state) => state.preference);
  useEffect(() => {
    if (otpCounter > 0) {
      const timer = setInterval(() => {
        setOtpCounter((prevCounter) => prevCounter - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [otpCounter]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };
  const emailValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .matches(/^\S+@\S+$/, "Email must not contain spaces")
      .required("Email is required."),
  });
  const emailSubmit = async (FormData, resetForm, setFieldError) => {
    dispatch(postStudioEmail(FormData))
      .unwrap()
      .then((result) => {
        if (result.data.success === false) {
          setFieldError("email", result.data.validation.errors.email[0]);
        } else {
          resetForm();
        }
      });
  };

  const onEmailVerifyOtp = async (code, email, type) => {
    setshowOtpErrors("");
    setCode(code);
    if (code?.length == 4) {
      const params = {
        otp: code,
        email: email,
      };
      const resultAction = await dispatch(verifyEmailOtp(params));

      if (verifyEmailOtp.fulfilled.match(resultAction)) {
        if (resultAction?.payload?.data?.status_code == "200") {
          dispatch(
            updatePreferenceList({
              type: "email",
              data: email,
            })
          );

          toast.success("Email Changed Successfully", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(authModalHandler(false));
          dispatch(isUpdatingEmailStatus(false));
        } else if (resultAction?.payload?.data?.status_code == "422") {
          setshowOtpErrors(resultAction?.payload?.data?.message);
        }
      }
    }
  };

  const resendOtp = async (email) => {
    setCode("");
    const resultAction = await dispatch(
      postResendStudioEmail({ email: email })
    );
    if (postStudioEmail.fulfilled.match(resultAction)) {
      setOtpCounter(180);
    }
  };
  return {
    code,
    showErrors,
    setShowErrors,
    setshowOtpErrors,
    showOtpErrors,
    emailValidationSchema,
    emailSubmit,
    onEmailVerifyOtp,
    isUpdatingEmail,
    otpCounter,
    setOtpCounter,
    resendOtp,
    formatTime,
  };
};
